import request from '@/utils/request';

// 需求2.0
// 版本库管理 创建
export function campusVersionLibraries(data) {
  return request({
    url: `/campus/app/version/libraries/`,
    method: 'post',
    data
  });
}
// 版本库管理 删除校园应用版本库
export function campusVersionLibrariesDel(params) {
  return request({
    url: `/campus/app/version/libraries/`,
    method: 'delete',
    params
  });
}
// 版本库管理 获取详细信息
export function getCampusVersionLibraries(id, params) {
  return request({
    url: `/campus/app/version/libraries/${id}`,
    method: 'get',
    params
  });
}
// 版本库管理 更新详细信息
export function updateCampusVersionLibraries(id, params) {
  return request({
    url: `/campus/app/version/libraries/${id}`,
    method: 'put',
    data: params
  });
}
// 版本库管理 禁用校园应用版本库
export function disableCampusVersionLibraries(params) {
  return request({
    url: `/campus/app/version/libraries/disable`,
    method: 'put',
    params
  });
}
// 版本库管理 启用校园应用版本库
export function enableCampusVersionLibraries(params) {
  return request({
    url: `/campus/app/version/libraries/enable`,
    method: 'put',
    params
  });
}
// 版本库管理 查询校园应用版本库分页列表
export function campusVersionLibrariesPage(params) {
  return request({
    url: `/campus/app/version/libraries/page`,
    method: 'get',
    params
  });
}
// 版本库管理 查询校园应用版本库最新关联明细列表
export function campusVersionAssociated(params) {
  return request({
    url: `/campus/app/version/libraries/details/latest/associated/list`,
    method: 'get',
    params
  });
}

